import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-demonstrate-owner-ship-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfDemonstrateOwnerShipIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfDemonstrateOwnerShipIcon(
  props: CcfDemonstrateOwnerShipIconProps
) {
  return (
    <SvgIcon
      {...props}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M29.4934 12.3739L15.9909 0.373125C15.7171 0.132631 15.3651 0 15.0007 0C14.6363 0 14.2843 0.132631 14.0105 0.373125L0.507944 12.3739C0.279613 12.5752 0.117946 12.8413 0.0444166 13.1367C-0.0291132 13.432 -0.0110262 13.7428 0.0962753 14.0277C0.203577 14.3125 0.395015 14.558 0.645162 14.7315C0.895309 14.905 1.19233 14.9983 1.49677 14.9991H2.99705V28.4999C2.99705 28.8978 3.15512 29.2793 3.43647 29.5606C3.71783 29.842 4.09943 30 4.49733 30H25.5013C25.8992 30 26.2808 29.842 26.5622 29.5606C26.8435 29.2793 27.0016 28.8978 27.0016 28.4999V14.9991H28.5019C28.8064 14.9986 29.1036 14.9055 29.354 14.7321C29.6044 14.5587 29.796 14.3132 29.9035 14.0283C30.011 13.7434 30.0292 13.4325 29.9557 13.137C29.8822 12.8415 29.7205 12.5753 29.4921 12.3739H29.4934ZM16.4996 26.9998H13.499V22.4995C13.499 22.1017 13.6571 21.7201 13.9385 21.4388C14.2198 21.1575 14.6014 20.9994 14.9993 20.9994C15.3972 20.9994 15.7788 21.1575 16.0602 21.4388C16.3415 21.7201 16.4996 22.1017 16.4996 22.4995V26.9998ZM24.001 26.9998H19.5002V22.4995C19.5002 21.306 19.026 20.1613 18.1819 19.3173C17.3378 18.4734 16.193 17.9992 14.9993 17.9992C13.8056 17.9992 12.6608 18.4734 11.8167 19.3173C10.9727 20.1613 10.4985 21.306 10.4985 22.4995V26.9998H5.99762V14.9991H24.001V26.9998ZM5.44251 11.9989L14.9993 3.50832L24.5575 11.9989H5.44251Z"
        fill="#007AB8"
      />
    </SvgIcon>
  );
}

export default CcfDemonstrateOwnerShipIcon;
